/* eslint-disable no-use-before-define,react-hooks/exhaustive-deps */

import React from 'react'
import { Field, FieldArray } from 'formik'
import { Fields, show, subscribe, unsubscribe, Dash, CORP_SECTORS, isEquals } from '../../twd'
import SubmitButton from './submit-button'
import { toSearchParams } from './to-search-params'
import { initialValues } from './use-quick-screener'
const { Labels} = Fields

let getResetValues = (curr) => {

    let a = Object.assign({}, curr);
    let b = Object.assign({}, initialValues);

    if (!isEquals(a,b)) {
        return Object.assign({}, initialValues, {
            holdSpRatingMin:'BBB-',
            holdSpRatingMax:'AAA',
            holdMoodyRatingMin:'Baa3',
            holdMoodyRatingMax:'Aaa',
        })
    }

    return Object.assign(b, {
        rating: "all-ratings",
        holdMoodyRatingMin: "ALL",
        holdMoodyRatingMax: "ALL",
        holdSpRatingMin: "ALL",
        holdSpRatingMax: "ALL",
    })
}

export default ({
    handleSubmit,
    values,
    errors,
    resetForm,
    validateForm,
}) => {

    React.useEffect(() => { validateForm() }, [])

    React.useEffect(() => {
        let subId = subscribe('corporates_quick_screener_clear_all.corporates_quick_screener_form', () => {
            resetForm(getResetValues(values))
            setTimeout(() => { validateForm() })
        })
        return () => {
            unsubscribe(subId)
        }
    }, [values])

    return (
    <form onSubmit={handleSubmit}>

    <div className="row">
    <div className="col-xs-12 col-md-12">
        <div className="row"><div className="col-xs-12">
            <Fields.Label
            label="Sectors"
            info={Labels.CorpSector}
            />
        </div></div>
        <FieldArray
            name="sectors"
            render={(args) => <Fields.SelectMulti {...args}
                dataName="corporates-quick-screener-sectors"
                emptyText='All'
                showSelectAll={true}
                options={CORP_SECTORS}
                style={{marginBottom:'10px'}}
            />}
        />
    </div>
    </div>

    <div className="row">
    <div className="col-xs-12 col-md-6">
        <div className="row"><div className="col-xs-12">
            <Fields.Label label="Maturity Date" info={Fields.Labels.Maturity} />
        </div></div>
        <div className="row">
            <div className="col-xs-6">
            <Field
                data-name="corporates-quick-screener-maturity-min"
                name="holdMaturityMin"
                component={Fields.Maturity}
                label="Min"
                error={errors.holdMaturity}
            />
            </div>
            <div className="col-xs-6">
            <Field
                data-name="corporates-quick-screener-maturity-max"
                name="holdMaturityMax"
                component={Fields.Maturity}
                label="Max"
                error={errors.holdMaturity}
            />
            </div>
            {errors.holdMaturity && (
                <label className="field-status has-error">{errors.holdMaturity}</label>
            )}
            <Dash />
        </div>
    </div>
    <div className="col-xs-12 col-md-6">
        <div className="row"><div className="col-xs-12">
            <Fields.Label label="Quantity" info={Fields.Labels.Quantity} />
        </div></div>
        <div className="row">
            <div className="col-xs-6 col-md-6">
            <Field
                data-name="corporates-quick-screener-quantity-min"
                name="quantityMin"
                component={Fields.Quantity}
                label="Min"
                error={errors.quantity}
            />
            </div>
            <div className="col-xs-6 col-md-6">
            <Field
                data-name="corporates-quick-screener-quantity-max"
                name="quantityMax"
                component={Fields.Quantity}
                label="Max"
                error={errors.quantity}
            />
            </div>
            {errors.quantity && (
                <label className="field-status has-error">{errors.quantity}</label>
            )}
            <Dash />
        </div>
    </div>
    </div>


    <div className="row">
    <div className="col-xs-12 col-md-6">
        <div className="row"><div className="col-xs-12">
            <Fields.Label label="Yield" info={Fields.Labels.Yield} />
        </div></div>
        <div className="row">
            <div className="col-xs-6">
            <Field
                data-name="corporates-quick-screener-yield-min"
                name="offerYtwMin"
                component={Fields.Yield}
                placeholder="%"
                error={errors.offerYtw}
                label="Min"
            />
            </div>
            <div className="col-xs-6">
            <Field
                data-name="corporates-quick-screener-yield-max"
                name="offerYtwMax"
                component={Fields.Yield}
                placeholder="%"
                error={errors.offerYtw}
                label="Max"
            />
            </div>
            {errors.offerYtw && (
                <label className="field-status has-error">{errors.offerYtw}</label>
            )}
            <Dash />
        </div>
    </div>
    <div className="col-xs-12 col-md-6">
        <div className="row"><div className="col-xs-12">
            <Fields.Label label="Price" info={Fields.Labels.Price} />
        </div></div>
        <div className="row">
            <div className="col-xs-6 col-md-6">
            <Field
                data-name="corporates-quick-screener-price-min"
                name="clientPriceMin"
                component={Fields.Price}
                placeholder="$"
                error={errors.clientPrice}
                label="Min"
            />
            </div>
            <div className="col-xs-6 col-md-6">
            <Field
                data-name="corporates-quick-screener-price-max"
                name="clientPriceMax"
                component={Fields.Price}
                placeholder="$"
                error={errors.clientPrice}
                label="Max"
            />
            </div>
            {errors.clientPrice && (
                <label className="field-status has-error">{errors.clientPrice}</label>
            )}
            <Dash />
        </div>
    </div>
    </div>


    <div className="row">
    <div className="col-xs-12 col-md-12">
        <div className="row"><div className="col-xs-12">
            <Fields.Label
                id="corporates-quick-screener-rating-label"
                label="Rating" info={Fields.Labels.Rating} />
        </div></div>

        <div className="row">
            <div className="col-xs-12 col-md-12">
            <Field
                data-name="corporates-quick-screener-rating-investment-grade"
                aria-describedby="corporates-quick-screener-rating-label"
                name="rating"
                component={Fields.Radio}
                value="investment-grade"
                label="Investment Grade"
                className="radio-inline"
                onClick={() => {
                    Object.assign(values, {
                        holdSpRatingMin:'BBB-',
                        holdSpRatingMax:'AAA',
                        holdMoodyRatingMin:'Baa3',
                        holdMoodyRatingMax:'Aaa'
                    })
                }} />
            &nbsp;
            &nbsp;
            <Field
                data-name="corporates-quick-screener-rating-high-yield"
                aria-describedby="corporates-quick-screener-rating-label"
                name="rating"
                component={Fields.Radio}
                value="high-yield"
                label="High Yield"
                className="radio-inline"
                onClick={() => {
                    Object.assign(values, {
                        holdSpRatingMin:'C',
                        holdSpRatingMax:'BB+',
                        holdMoodyRatingMin:'C',
                        holdMoodyRatingMax:'Ba1'
                    })
                }} />
            &nbsp;
            &nbsp;
            <Field
                data-name="corporates-quick-screener-rating-all-ratings"
                name="rating" component={Fields.Radio}
                value="all-ratings"
                label="All ratings"
                className="radio-inline"
                onClick={() => {
                    Object.assign(values, {
                        holdSpRatingMin:'ALL',
                        holdSpRatingMax:'ALL',
                        holdMoodyRatingMin:'ALL',
                        holdMoodyRatingMax:'ALL'
                    })
                }} />
            </div>
        </div>
    </div>
    </div>


    <div className="row">
    <div className="col-xs-12 col-md-12 col-lg-6">
        <div className="row"><div className="col-xs-12">
            <Fields.Label label="Moody's" />
        </div></div>
        <div className="row">
            <div className="col-xs-6">
            <Field
                dataName="corporates-quick-screener-moodys-credit-rating-min"
                name="holdMoodyRatingMin"
                component={Fields.Rating}
                ratingType='moodys'
                error={errors.holdMoodyRating}
                label='Min'
                ariaLabel="Minimum Moody's Rating"
            />
            </div>
            <div className="col-xs-6">
            <Field
                dataName="corporates-quick-screener-moodys-credit-rating-max"
                name="holdMoodyRatingMax"
                component={Fields.Rating}
                ratingType='moodys'
                error={errors.holdMoodyRating}
                label='Max'
                ariaLabel="Maximum Moody's Rating"
            />
            </div>
            {errors.holdMoodyRating && (
                <label className="field-status has-error">{errors.holdMoodyRating}</label>
            )}
            <Dash margin={10} />
        </div>
    </div>
    <div className="col-xs-12 col-md-12 col-lg-6">
        <div className="row"><div className="col-xs-12">
            <Fields.Label label="S&amp;P" />
        </div></div>
        <div className="row">
            <div className="col-xs-6 col-md-6">
            <Field
                dataName="corporates-quick-screener-sp-credit-rating-min"
                name="holdSpRatingMin"
                component={Fields.Rating}
                ratingType='sp'
                error={errors.holdSpRating}
                label='Min'
                ariaLabel="Minimum S&ampP Rating"
            />
            </div>
            <div className="col-xs-6 col-md-6">
            <Field
                dataName="corporates-quick-screener-sp-credit-rating-max"
                name="holdSpRatingMax"
                component={Fields.Rating}
                ratingType='sp'
                error={errors.holdSpRating}
                label='Max'
                ariaLabel="Maximum S&ampP Rating"
            />
            </div>
            {errors.holdSpRating && (
                <label className="field-status has-error">{errors.holdSpRating}</label>
            )}
            <Dash margin={10} />
        </div>
    </div>
    </div>

    <div className="row vertical-offset-xs"></div>

    <div className="row">
    <div className="col-xs-12 col-md-12">
        <Field
            data-name="corporates-quick-screener-credit-ratings-and-or"
            name="holdRatingAndOr"
            component={Fields.Checkbox}
            label="Results can match Moody's or S&amp;P ratings selection"
        />
    </div>
    </div>

    <div className="row">
    <div className="col-xs-12 col-md-12">
        <Field
            data-name="corporates-quick-screener-exclude-callable"
            name="holdCallableInd"
            component={Fields.Checkbox}
            label="Exclude Callable"
        />
    </div>
    </div>

    <div className="row vertical-offset-base"></div>

    <div className="row">
    <div className="col-xs-12 col-md-12">
        <SubmitButton errors={errors} values={values} />
    </div>
    </div>

    <div className="row">
        <div className="col-xs-12 text-center">
            <button
                data-name="corporates-quick-screener-advanced-screener"
                className="btn btn-link"
                onClick={() => {
                    let p = toSearchParams(values)
                    p.isEdit = true

                    show('advanced-screener', Object.assign({
                        searchParams: p,
                        _ts: Date.now(),
                        from:'corporates'
                    }))
                }}
            >Advanced Screener</button>
        </div>
    </div>

    </form>
    )
}
